import { Card, Skeleton } from "@mui/material";


export const CustomSkeleton = ({width, height, marginTop}) => {
    return (
        <Skeleton>
            <Card
                sx={{
                    width: width,
                    height: height,
                    marginTop: marginTop,
                }}
            ></Card>
        </Skeleton>
    );
}